export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14613.869a8d06.jpg";